import { mq } from "../../../cssInJs";

export default {
  pay: {
    'h3': {
      marginTop: 0
    }
  },
  stripeWrapper: {
    margin: '1rem 0 1rem',
    maxWidth: 500,
    padding: '1rem',
    backgroundColor: '#999999'
  },
  ewayWrapper: {
    margin: '1rem 0 1rem',
    maxWidth: 500,
    padding: '1rem',
    backgroundColor: '#f2f2f2',
    border: '1px solid #ddd',
    borderRadius: 4,
  },
  ewayLabel: {
    fontSize: '0.9rem',
    marginBottom: '0.3rem',
  },
  ewayInfoText: {
    fontSize: '0.8rem',
    marginTop: '0.5rem',
    color: '#555',
  },
  payeeText: {
    marginTop: '1rem',
    fontSize: '0.85rem',
    color: '#555',
  },
  formActions: {
    marginTop: '2rem'
  },
  paymentInfoText : mq({
    fontSize: ['0.6rem', '0.5rem'],
    marginTop: '1rem',
    '.contact-link' : {
      color: 'white'
    }
  })
}